module.exports = __webpack_public_path__ + "img/cooperation_unit_13.0f9dfeae.png";